export default "/assets/site/images/3.png?9834e3eaa6e175aec8277f1fdbb5c689";